import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  borderRadius: theme.spacing(1),
}));

interface StyledAccordionSummaryProps {
  padding?: number;
  flexDirection?: 'row-reverse' | 'row' | 'column' | 'column-reverse';
}

const shouldForwardProp = (prop: PropertyKey) =>
  !['flexDirection', 'padding'].includes(prop as string);

export const StyledAccordionSummary = styled(AccordionSummary, {
  shouldForwardProp,
})<StyledAccordionSummaryProps>(({ theme, padding = 3, flexDirection = 'row' }) => ({
  padding: theme.spacing(padding),
  flexDirection: flexDirection,
  gap: theme.spacing(1.5),
  '& .MuiAccordionSummary-content': {
    margin: 0,
  },
}));

interface StyledAccordionDetailsProps {
  padding?: number;
}

export const StyledAccordionDetails = styled(AccordionDetails)<StyledAccordionDetailsProps>(
  ({ theme, padding = 3 }) => ({
    padding: theme.spacing(0, padding, padding),
  })
);

export const StyledHeaderContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(1.5),
}));
